import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getTrelloActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({trello}: BackupState) => trello.actions);
export const getTrelloActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({trello}: BackupState) => trello.totalActions);
export const isTrelloActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({trello}: BackupState) => trello.loading);
export const getTrelloCanRestore = createSelector((state: DefaultRootState) => state.backups, ({trello}: BackupState) => trello.canRestore);
